import { render, staticRenderFns } from "./TopTeam.vue?vue&type=template&id=2bc901f9"
import script from "./TopTeam.vue?vue&type=script&lang=js"
export * from "./TopTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports